import React from 'react';
import { Box, InputAdornment, Divider, TextField, styled, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface IChatSearchBarProps {
  searchHandler: (_value: React.ChangeEvent<HTMLInputElement>) => void;
  searchText: string;
  onClick?: (_event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const SearchInput = styled(TextField)(({ theme }) => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    backgroundColor: 'var(--Accent-White, #FFF)',
    '& fieldset': {
      border: '1px solid rgba(124, 174, 190, 0.50)',
    },
    '&:hover fieldset': {
      border: '1px solid rgba(124, 174, 190, 0.50)',
    },
    '&.Mui-focused fieldset': {
      border: '1px solid rgba(124, 174, 190, 0.50)',
    },
  },
  '& .MuiInputBase-input': {
    ...theme.typography.bodyRegular,
    '&:-webkit-autofill': {
      '-webkit-text-fill-color': theme.palette.primary.main,
      '-webkit-box-shadow': `0 0 0 1000px ${'var(--Accent-White, #FFF)'} inset`,
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: '8px 12px',
    fontSize: '17px',
    lineHeight: '22px',
    color: theme.palette.primary.main,
    fontFamily: 'Satoshi',
  },
}));

function ChatSearchBar({ searchHandler, searchText, onClick }: IChatSearchBarProps) {
  const { t } = useTranslation();

  return (
    <>
      <Box
        width="100%"
        display="flex"
        p={2}
        borderRadius="5px 0 0 0"
        height="70px"
        gap={1}
        alignItems="center"
      >
        <SearchInput
          placeholder={`${t('common.search')}...`}
          onChange={searchHandler}
          value={searchText}
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <img src="/assets/icons/magnifer.svg" alt="search" />
              </InputAdornment>
            ),
          }}
        />
        <IconButton onClick={onClick}>
          <img
            src="/assets/icons/new-conversation.svg"
            alt="new-conversation"
            style={{ cursor: 'pointer' }}
          />
        </IconButton>
      </Box>

      <Divider sx={{ borderColor: 'rgba(124, 174, 190, 0.50)' }} />
    </>
  );
}

export default ChatSearchBar;
